import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import UnpackItem from 'components/Sales/Smart/Prepack/unpack/unpackItem';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function SmartUnpackItem(): JSX.Element {
  return (
    <ContentLayout 
        titleKey="titles.unpackItem" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
     >
      <UnpackItem />
    </ContentLayout>
  );
}
